<template>
  <DialogFull
    :data="dialogSettings"
    v-if="dialogSettings.dialog"
    @close="close"
  >
    <template v-slot:dialog.body>
      <div class="container mt-10">
        <h1>{{ dialogSettings.title }}</h1>
        <InterviewFormatTemplateForm
          ref="interviewFormatTemplate"
          :interviewFormatTemplate="interviewFormatTemplate"
          @onSubmit="editTemplate"
        />
      </div>
    </template>
    <template v-slot:dialog.action>
      <PrimaryButton
        @click.native="validateForm"
        :loading="isEditingBookingTemplate"
      >
        Save Changes
      </PrimaryButton>
    </template>
  </DialogFull>
</template>

<script>
import DialogFull from "@/components/common/DialogFull";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { createNamespacedHelpers } from "vuex";
import { ORGANISATION_INTERVIEW_FORMAT_TEMPLATES_NAMESPACE } from "@/store/modules/organisations/organisation-interview-format-templates";
import { EDIT_INTERVIEW_FORMAT_TEMPLATE } from "@/store/modules/organisations/organisation-interview-format-templates/actions";
import InterviewFormatTemplateForm from "@/views/settings/components/interview-format-templates/components/InterviewFormatTemplateForm";

const { mapActions } = createNamespacedHelpers(
  ORGANISATION_INTERVIEW_FORMAT_TEMPLATES_NAMESPACE
);
export default {
  props: {
    isOpen: Boolean,
    interviewFormatTemplate: Object
  },
  components: {
    PrimaryButton,
    DialogFull,
    InterviewFormatTemplateForm
  },
  data() {
    return {
      isEditingBookingTemplate: false
    };
  },
  computed: {
    dialogSettings() {
      return {
        dialog: this.isOpen,
        title: "Edit Interview Template"
      };
    }
  },
  methods: {
    ...mapActions({
      editInterviewTemplate: EDIT_INTERVIEW_FORMAT_TEMPLATE
    }),
    validateForm() {
      this.$refs.interviewFormatTemplate.validateForm();
    },
    async editTemplate(templateData) {
      this.isEditingBookingTemplate = true;
      await this.editInterviewTemplate(templateData);
      this.close();
      this.isEditingBookingTemplate = false;
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss"></style>
